import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';
import Img from 'components/Img';

const StyledImg = styled(withParallax(styled(Img)`
  width: 80px;
  height: 80px;

  ${media.medium`
    width: 8vw;
    height: 8vw;
  `}
`))`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);

  ${media.medium`
    width: 8vw;
    height: 8vw;
  `}
`;

StyledImg.defaultProps = {
  backgroundColor: 'transparent',
  scaleMode: 'contain',
};

export default StyledImg;
